import type { PortalV2Location } from "./types";

export class PortalV2FetchError extends Error {
	status: number;

	constructor({ status, message }: { status: number; message: string }) {
		super(message);
		this.status = status;
	}
}

export async function fetchPortalV2LocationByLookup({
	lookupId,
}: {
	lookupId: string;
}): Promise<PortalV2Location> {
	const url = `${process.env.NEXT_PUBLIC_API_URL}/v2/portal/locationLookups/${lookupId}`;
	const response = await fetch(url);

	if (!response.ok) {
		throw new PortalV2FetchError({
			status: response.status,
			message: `Failed to fetch location by lookup: ${response.statusText}`,
		});
	}

	return response.json();
}

export async function fetchPortalV2LocationByIdentifier({
	identifier,
}: {
	identifier: string;
}): Promise<PortalV2Location> {
	const url = `${process.env.NEXT_PUBLIC_API_URL}/v2/portal/locations/${identifier}`;
	const response = await fetch(url);

	if (!response.ok) {
		throw new PortalV2FetchError({
			status: response.status,
			message: `Failed to fetch location by identifier: ${response.statusText}`,
		});
	}

	return response.json();
}
